import { Component, OnInit, Input, ChangeDetectorRef, Inject ,PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import 'rxjs/add/operator/first';
import { DEVICE_INFO, APP_SETTINGS,  DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.template.html',
  styleUrls: ['./user-profile.style.scss']
})
export class UserProfile implements OnInit {

  @Input() profile: any;
  @Input() toggleLabel: string;
  public toggleState: boolean = false;
  public welcomeText: string;
  private initialEmail: string;
  public errorMessage: string = null;
  public passwordChangeMessage: string = null;
  public passwordInvalidMessage: string = 'You need to enter password that contains 8 or more characters and matches the requirements above';
  public  newPassword: string = null;
  public  confirmNewPassword: string = null;
  public isClient: boolean = false;
  private invalid: boolean = false;
  public isPhone: boolean = false;
  constructor(
    private cd: ChangeDetectorRef,
    private authService: UserLoginService,
    private coreEffects: CoreEffects,
    private interactions : EventInteraction,
    @Inject(DEVICE_INFO) device: DeviceInfo,
    @Inject(PLATFORM_ID) protected platformId: string,
    private router: Router,
  ) {
    this.isClient = isPlatformBrowser(this.platformId);
    this.isPhone = device.isPhone;
   }

  ngOnInit() {
    if (this.isClient){
      this.toggleLabel = "VIEW MORE";
      if (this.profile){
        //const name = (this.profile.name) ? this.profile.name : this.profile.preferred_username;
        //this.welcomeText = "Welcome, " + name + ".";
        this.initialEmail = this.profile.email;
      }
    }
  }

  public toggle(){
    this.toggleState = !this.toggleState;
    //this.toggleLabel = (this.toggleLabel.indexOf("MORE") > -1) ? "VIEW LESS" : "VIEW MORE";
    this.cd.detectChanges();
  }

  public invalidPassword(){
    let invalid:boolean = false;

    this.passwordInvalidMessage = '';

    if (!this.newPassword || this.newPassword.length < 8){
      this.passwordInvalidMessage = '<p>You need to enter password that contains 8 or more characters and matches the requirements above</p>';
      return true;
    }
    //if (/\d/.test(string) && /[a-zA-Z]/.test(string)) {

    if (!/[a-z]/.test(this.newPassword)){
      this.passwordInvalidMessage += '<p>Your password must contain at least 1 lowercase letter</p>';
      invalid = true;
    }  
    if (!/[A-Z]/.test(this.newPassword)){
      this.passwordInvalidMessage += '<p>Your password must contain at least 1 uppercase letter</p>';
      invalid = true;
    } 
    if (!/\d/.test(this.newPassword)){
      this.passwordInvalidMessage += '<p>Your password must contain at least 1 number</p>';
      invalid = true;
    }  
    if (!/[!#$^*]/.test(this.newPassword)){
      this.passwordInvalidMessage += '<p>Your password must contain at least 1 special character from "!#$^*"</p>';
      invalid = true;
    }  
    if (this.newPassword != this.confirmNewPassword){
      this.passwordInvalidMessage += '<p>Passwords do not match</p>';
      invalid = true;
    }

    if(invalid != this.invalid)
    {
      this.invalid = invalid;
      //this.cd.detectChanges();
    }
    
    return invalid;
  }

  refreshPasswordInput(ev){
    //this.changePassword = ev.value;
    this.cd.detectChanges();
  }

  public changePassword(){
    const self = this;
    this.passwordChangeMessage = null;
    this.coreEffects.changePassword(this.newPassword)
      .first()
      .subscribe(res=>{
        //console.log(res);
        if (res['has_error']){
          self.passwordChangeMessage = res['error']['error'];
        }
        else{
          self.passwordChangeMessage = "You have successfully updated your password";
        }
        self.cd.detectChanges();
      })
    
  }
  public logout(){
    this.interactions.next({key: 'user-request-logout', message: null})
  }
  public submit(){
    //patchProfile
    if (this.profile.email != this.initialEmail){
      this.profile['new_email'] = this.profile.email;
      this.profile.email = this.initialEmail;
    }
    const self = this;
    this.coreEffects.patchProfile(this.profile)
      .first()
      .subscribe(res=>{
        //console.log(res);
        if (res['has_error']){
          this.errorMessage = 'Email ' +res['error']['email'][0];
          self.profile['new_email'] = self.initialEmail;
        }
        else{
          if (self.profile['new_email'] && self.profile['new_email'] != self.profile.email){
            self.profile.email = self.profile['new_email'];
          }
          self.errorMessage = 'You have successfully updated your profile';
          this.coreEffects.setInternalStateValue('user_profile', self.profile);
        }
        self.cd.detectChanges();
      })
    
    //console.log(this.profile);
  }

}




// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/user-profile/user-profile.component.ts